var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OPTION 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OPTION-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.500000, 2.000000)",
    fill: "#188C19",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75513428,3.37507799e-14 L2.28190276,3.37507799e-14 C1.02164266,3.37507799e-14 1.8562929e-13,1.02164266 1.8562929e-13,2.28190276 L1.8562929e-13,6.53004505 C1.8562929e-13,7.79030515 1.02164266,8.81194781 2.28190276,8.81194781 L9.75513428,8.81194781 C11.0153944,8.81194781 12.037037,7.79030515 12.037037,6.53004505 L12.037037,2.28190276 C12.037037,1.02164266 11.0153944,3.37507799e-14 9.75513428,3.37507799e-14 Z M6.08507402,6.27523258 C5.50651176,6.85057057 4.57189208,6.85057057 3.99332982,6.27523258 L2.74969282,5.03159558 L3.55596513,4.22532327 L4.79960213,5.46896027 C4.93478484,5.59790608 5.14742217,5.59790608 5.28260488,5.46896027 L8.48107191,2.27049324 L9.28734422,3.07676555 L6.08507402,6.27523258 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1,
    y: 10,
    width: 10,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.5,
    y: 12,
    width: 7,
    height: 1,
    rx: 0.475396407
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishAll);
export default __webpack_public_path__ + "static/media/publish_all.6e85e6072b731de931fd098e9bc52a47.svg";
export { ForwardRef as ReactComponent };